export const ROUTES = {
  AUTH: {
    BASE: 'auth',
    CONFIRMATION: 'auth.confirmation',
    GROUP_SIZE: 'auth.group_size',
    LOGIN: 'auth.login',
    LOGOUT: 'auth.logout',
    OPTIONS: 'auth.options',
  },
  HOME: 'home',
  HUNT: {
    CONGRATULATIONS: 'hunt.congratulations',
    RIDDLE: 'hunt.riddle',
    WELCOME: 'hunt.welcome',
  },
  TERMS: {
    PRIVACY: 'terms.privacy',
    RULES: 'terms.rules',
    TERMS: 'terms.terms',
  },
  WARDROBE: 'wardrobe',
}
